import EditProjectModal from './EditProjectModal';

export default EditProjectModal;
